<template>
  <v-card>
    <v-icon class="close" @click="close()">$sl-close</v-icon>
    <v-card-title>
      <h4>{{ editedItem.id ? "Ändra moment" : "Lägg till delmoment"}}</h4>
    </v-card-title>

    <v-card-text>
      <v-form ref="form">
      <v-text-field :rules="[rules.required]" outlined v-model="name" label="Momentnamn"></v-text-field>      
      <v-textarea
        outlined
        rows="4"
        v-model="description"
        label="Momentbeskrivning"
      ></v-textarea>

        <template v-if="editedItem.id">
          <MessageBox class="mt-n2">
            <p>
              Om du ändrar kurs nedan till EN annan kurs än denna kommer detta moment att flyttas från denna kurs. Om du ändrar till FLERA kurser kommer momentet att flyttas till en av dessa och kopieras till övriga. Dessa kopior kan ändras separat och blir frikopplade från varandra. Flytten sker när du sparar.
            </p>
          </MessageBox>
        </template>

        <v-select
          v-model="courses"
          class="mt-4"
          label="Kurs som momentet hör till"
          :items="practicalCourses.map(o => {return {text: o.courseName, value: o.id}})"
          multiple
          chips
        />

      </v-form>
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn color="secondary" @click="close()">
        <v-icon>$sl-cancel</v-icon>Avbryt
      </v-btn>
      <v-btn class="icon" @click="save()">
        <v-icon>$sl-check</v-icon>Spara
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {RulesMixin} from '@/components/mixins'
import MessageBox from '@/components/common/MessageBox.vue'
import sortBy from 'lodash/sortBy'

// @group Ebook
// Styled ProviderBookElementsModal component
export default {
  name: 'ElementModal',

  props: {
    //has edited item
    editedItem: Object,
    professionId: Number,
    reform: String
  },

  mixins: [RulesMixin],

  components: {
    MessageBox
  },

  data: () => ({    
    name: '',
    description: '',
    practicalCourses: [],
    courses: []
  }),

  created(){    
    this.init()
  },

  watch: {
    editedItem: function () {
      this.init()
    },
  },

  methods: {
    init() {
      this.name=this.editedItem.name
      this.description=this.editedItem.description
      this.courses=[this.editedItem.courseId]

      API.listPlainProfessionCourses(this.professionId, { data: { reform: this.reform } })
      .then(res=>{
        this.practicalCourses = sortBy(res.data, ['groupName', 'courseName'] )
      })
      .catch(error=>{
        console.log(error)
      })

    },

    close(){
      this.name=this.editedItem.name
      this.description=this.editedItem.description
      this.courses=[this.editedItem.courseId]
      this.$emit('close')
    },

    async save() {
      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
        return
      }

      await API.updateElement(this.editedItem.id, {
          data: {name: this.name, description: this.description}
        }).catch(err => {console.log(err)})

        this.editedItem.name=this.name
        this.editedItem.description=this.description

        //- Do we want to move or copy stuff
        if (this.courses.length > 1 ||  (this.courses.length === 1 && this.courses[0] !== this.editedItem.courseId)) {
          await API.moveElement(this.editedItem.id, {
              data: {courseIds: this.courses}
            }).catch(err => {console.log(err)})

          this.$events.fire('showInfo', 'Flyttad/Kopierad.')
          this.$emit("move");
        } else {
          this.$events.fire('showInfo', 'Sparad.')
          this.$emit("save", this.editedItem);
        }
      }
  }
}
</script>

<style lang="scss" scoped>
</style>